import { faCircleExclamation, faTrashCan, faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import { Button, Input, UserfulTooltip } from "userful-chronos-common-ui/dist";
import { UserfulConfirmationDialog } from "userful-chronos-common-ui/dist/widgets";
import { apiDeleteConstellation } from "../../../../messages/api/gcmAPICallers";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { IConstellationInfo } from "../../../../model/CarbonExternalModels";
import { useState } from "react";
import { GcmUserPermission } from "userful-chronos-app-common-js/dist/models/gcm-user-permission";
import { AppSliceActions } from "../../../../store/app/appSlice";
import { useCarbonDispatch } from "../../../../store/carbonStore";

interface IProps {
    type: "SECONDARY" | "DROPDOWN";
    constellations: { [id: string]: IConstellationInfo };
    onDelete?: () => void;
}

export default function DeleteConstellation(props: IProps) {
    const dispatch = useCarbonDispatch();

    const [input, setInput] = useState<string>("");
    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

    const permissions: GcmUserPermission = getGlobalStates().gcmUserPermission;

    if (!permissions.isConstellationSuppressor && !permissions.isConstellationCreator) return null;

    const atLeastOneCannot = Object.keys(props.constellations).some((key) => {
        const constellation = props.constellations[key];
        return constellation.cluster.length > 0;
    });

    const numberOfConstellations = Object.keys(props.constellations).length;
    const firstConstellation = Object.values(props.constellations)[0];

    return (
        <>
            {props.type === "SECONDARY" && (
                <UserfulTooltip title={numberOfConstellations > 1 ? "Delete All" : "Delete"}>
                    <Button variant="secondary" iconOnly onClick={(e) => setShowConfirmation(true)}>
                        <FontAwesomeIcon icon={faTrashCan} />
                    </Button>
                </UserfulTooltip>
            )}
            {props.type === "DROPDOWN" && (
                <Dropdown.Item onClick={(e) => setShowConfirmation(true)}>
                    <div className="gcm-icon-dropdown-menu-icon-container">
                        <FontAwesomeIcon icon={faTrashCan} />
                    </div>
                    <p> {numberOfConstellations > 1 ? "Delete All" : "Delete"}</p>
                </Dropdown.Item>
            )}

            <UserfulConfirmationDialog
                show={showConfirmation}
                gap={8}
                icon={{ icon: faTriangleExclamation }}
                title={"Delete Constellation"}
                varient="danger"
                replaceBody={
                    <>
                        {!atLeastOneCannot && (
                            <>
                                <p>
                                    Are you sure you want to delete{" "}
                                    <strong>{firstConstellation.definition.name}</strong>
                                    {numberOfConstellations > 1 && (
                                        <>
                                            {"   "}
                                            <span className="userful-exclusive-count-badge">
                                                +{numberOfConstellations - 1}
                                            </span>
                                        </>
                                    )}
                                    ?{"   "}
                                    This will permanentaly remove all the data related this constellation.
                                </p>
                                {numberOfConstellations > 1 && (
                                    <Input
                                        filedTitle="Please type 'DELETE' to confirm."
                                        value={input}
                                        onChange={(e) => {
                                            setInput(e.target.value);
                                        }}
                                    />
                                )}
                            </>
                        )}
                        {atLeastOneCannot && (
                            <>
                                <p>
                                    You are not able to delete <strong>{firstConstellation.definition.name}</strong>
                                    {numberOfConstellations > 1 && (
                                        <>
                                            {"   "}
                                            <span className="userful-exclusive-count-badge">
                                                +{numberOfConstellations - 1}
                                            </span>
                                        </>
                                    )}
                                    !{"   "}
                                    {numberOfConstellations === 1 &&
                                        "Clusters are currently assigned to this constellation."}
                                    {numberOfConstellations > 1 &&
                                        "One or more constellations currently have clusters assigned to them."}
                                </p>
                                <p className="userful-warning-text">
                                    <FontAwesomeIcon icon={faCircleExclamation} />
                                    {"   "}
                                    Please remove all the clusters from constellation(s) before deleting.
                                </p>
                                {numberOfConstellations > 1 && (
                                    <Input
                                        filedTitle="Please type 'DELETE' to confirm."
                                        value={input}
                                        onChange={(e) => {
                                            setInput(e.target.value);
                                        }}
                                    />
                                )}
                            </>
                        )}
                    </>
                }
                replaceFooter={
                    <>
                        <Button
                            variant="secondary"
                            onClick={(e) => {
                                setShowConfirmation(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="danger"
                            disabled={atLeastOneCannot || (numberOfConstellations > 1 && input !== "DELETE")}
                            onClick={(e) => {
                                setShowConfirmation(false);

                                if (props.onDelete) props.onDelete();

                                dispatch(AppSliceActions.setAppView({ type: "CONSTELLATIONS" }));

                                for (const key in props.constellations) {
                                    apiDeleteConstellation(
                                        getGlobalStates().keycloak.token,
                                        props.constellations[key].definition.id,
                                    );
                                }
                            }}
                        >
                            {numberOfConstellations > 1 ? "Delete All" : "Delete"}
                        </Button>
                    </>
                }
                onCancel={() => {
                    setShowConfirmation(false);
                }}
            />
        </>
    );
}
